import {useCallback, useEffect} from "react";
import {useComputed, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {DATE_METRICS, GROUPED_BY} from "@constants";
import {useToast} from "@hooks";
import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {isBannersPercentageEmpty} from "../@signals";


const translateKey = key => {
    if (key === DATE_METRICS.DAILY)
        return 'Date'
    else if (key === DATE_METRICS.WEEKLY)
        return 'Weekly'
    else if (key === DATE_METRICS.MONTHLY)
        return 'Monthly'
    else if (key === DATE_METRICS.QUARTERLY)
        return 'Quarterly'
    else if (key === DATE_METRICS.YEARLY)
        return 'Yearly'
    else if (key === GROUPED_BY.COUNTRY)
        return 'Country'
    else if (key === GROUPED_BY.RETAILER)
        return 'Retailer'
    else if (key === GROUPED_BY.COMPANY)
        return 'Company'
    else if (key === GROUPED_BY.BRAND)
        return 'Brand'
    else if (key === GROUPED_BY.PAGE_CATEGORY)
        return 'Mono/Multi Brand'
    else if (key === GROUPED_BY.PAGE_PRODUCT_TYPE)
        return 'Page Product Type'
    else if (key === GROUPED_BY.IMAGE_TYPE)
        return 'Image Type'
    else if (key === GROUPED_BY.TAG)
        return 'Tag'
    return key
}

export default function useBannerPercentageSearch(url, forceLoad=false, extraData={}, needPrevious=true) {
    const { showToast } = useToast()

    const currentData = useSignal([])
    const isLoadingCurrent = useSignal(false)
    const previousData = useSignal([])
    const isLoadingPrevious = useSignal(false)
    const extraResponse = useSignal({})
    const totalTitle = useSignal(translateKey(extraData.splitKpi[0]))
    const shareTitle = useSignal(translateKey(extraData.splitKpi[1]))

    const isLoading = useComputed(() => isLoadingPrevious.value || isLoadingCurrent.value)

    useEffect(() => {
        totalTitle.value = translateKey(extraData.splitKpi[0])
        shareTitle.value = translateKey(extraData.splitKpi[1])
    }, [JSON.stringify(extraData.splitKpi)]);

    useEffect(() => {
        if (isLoadingCommonFilters.value || forceLoad)
            handleSubmit()
    }, [isLoadingCommonFilters.value, forceLoad]);

    const handleSubmit = () => {
        isLoadingCurrent.value = true
        postSubmit(url, {
            ...commonFiltersValue.value,
            ...extraData
        }).then(({ data, ...res }) => {
            isLoadingCurrent.value = false
            if (!data.length) {
                isBannersPercentageEmpty.value = true
                isLoadingCommonFilters.value = false
            } else {
                currentData.value = data
                extraResponse.value = res
            }
        }).catch(() => {
            showToast.error()
            isLoadingCurrent.value = false
            currentData.value = []
            extraResponse.value = {}
        })

        if (needPrevious) {
            isLoadingPrevious.value = true
            postSubmit(url, {
                ...commonFiltersValue.value,
                startDate: commonFiltersValue.value.prevStartDate,
                endDate: commonFiltersValue.value.prevEndDate,
                ...extraData
            }).then(r => {
                isLoadingPrevious.value = false
                previousData.value = r.data
            }).catch(() => {
                showToast.error()
                isLoadingPrevious.value = false
                previousData.value = {}
            })
        }
    }

    const handleDownload = useCallback(() => {
        return showToast.promiseExcel(`${url}/excel`, {
            ...commonFiltersValue.value,
            ...extraData
        })
    }, [JSON.stringify(extraData)])

    return {
        currentData: currentData.value,
        previousData: previousData.value,
        ...extraResponse.value,
        totalTitle: totalTitle.value,
        shareTitle: shareTitle.value,

        isLoading: isLoading.value,
        handleDownload
    }
}